exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3JZg{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "_3JZg",
	"root": "_3JZg"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/PromotionsSidebar/PromotionsSidebar.css
// module id = 228
// module chunks = 0